import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";

const Profile = () => {
  const [menu, setMenu] = useState(false);
  const [User, SetUser] = useState({
    blood_group: "",
    date_time: "",
    department: "",
    dob: "",
    doj: "",
    emergency_con_number: "",
    emergency_con_person: "",
    emp_type: "",
    id: "",
    incharge: "",
    last_login: "",
    location: "",
    mobile: "",
    name: "",
    password: "",
    relationship_contact: "",
    salary: "",
    shift_intime: "",
    shift_outtime: "",
    status: "",
    stay: "",
    user_type: ""
  })

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    const userString = localStorage.getItem("User");
    const user = userString ? JSON.parse(userString) : null;
    SetUser(user);
  },[])

  function formatSimpleDate(dateStr) {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  function formatTimeTo12Hour(time24) {
  const [hourStr, minuteStr] = time24.split(":");
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  const isPM = hour >= 12;
  const period = isPM ? "pm" : "am";

  hour = hour % 12 === 0 ? 12 : hour % 12;
  const minuteFormatted = minute < 10 ? `0${minute}` : minute;

  return `${hour}:${minuteFormatted}${period}`;
}


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        {/** Page Wrapper  */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row justify-content-lg-center">
              <div className="col-lg-10">
                {/* Page Header */}
                <div className="page-header">
                  <div className="content-page-header">
                    <h5>Profile</h5>
                  </div>
                </div>
                {/* /Page Header */}


                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="col-md-12">
                        <div className="plane-basic-info plane-detail">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Name</h6>
                                  <p>{User.name}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Blood Group</h6>
                                  <p>{User.blood_group}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Mobile No</h6>
                                  <p><a
    href={`tel:${User.mobile}`}     /* or your own button classes */
    style={{ textDecoration: "none" }} /* remove underline */
  >
    {User.mobile}
  </a></p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6> Password</h6>
                                  <p>{User.password}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6> Employee Type</h6>
                                  <p>{User.emp_type}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Date Of Birth</h6>
                                  <p>{formatSimpleDate(User.dob)}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Department</h6>
                                  <p>{User.department}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Date Of Joining</h6>
                                  <p>{formatSimpleDate(User.doj)}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Emergency Contact Name</h6>
                                  <p>{User.emergency_con_person}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Emergency Contact Number</h6>
                                  <p><a
    href={`tel:${User.emergency_con_number}`}     /* or your own button classes */
    style={{ textDecoration: "none" }} /* remove underline */
  >
    {User.emergency_con_number}
  </a></p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Salary</h6>
                                  <p>₹ {User.salary}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Shift In</h6>
                                  <p>{formatTimeTo12Hour(User.shift_intime)}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>Shift Out</h6>
                                  <p>{formatTimeTo12Hour(User.shift_outtime)}</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-6">
                                <div className="basic-info-detail">
                                  <h6>User Type</h6>
                                  <p>{User.user_type}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Profile;
